import * as React from "react";
import type { SVGProps } from "react";
const SvgInfoComposition = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#info-composition_svg__a)">
      <path d="M6 18A6 6 0 1 1 6 6a6 6 0 0 1 0 12M6 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8M18 24a6 6 0 1 1 0-12 6 6 0 0 1 0 12m0-10a4 4 0 1 0 0 8 4 4 0 0 0 0-8" />
      <path d="M18 12a6 6 0 1 1 0-12 6 6 0 0 1 0 12m0-10a4 4 0 1 0 0 8 4 4 0 0 0 0-8" />
      <path d="M10.5 10.75a1 1 0 0 1-.946-1.31 1 1 0 0 1 .496-.58l3-1.5A1.009 1.009 0 0 1 14 9.14l-3 1.5a.93.93 0 0 1-.5.11M13.5 16.75a.93.93 0 0 1-.45-.11l-3-1.5a.999.999 0 1 1 .9-1.78l3 1.5a1 1 0 0 1-.45 1.89M6 14.8a1 1 0 0 1-1-1v-1.2a1 1 0 1 1 2 0v1.2a1 1 0 0 1-1 1M6 11.2a1 1 0 0 1-.38-.08 1.2 1.2 0 0 1-.33-.21 1.2 1.2 0 0 1-.21-.33.94.94 0 0 1 0-.76 1.2 1.2 0 0 1 .21-.33 1.2 1.2 0 0 1 .33-.21 1 1 0 0 1 .76 0q.183.077.33.21.134.147.21.33a.94.94 0 0 1 0 .76 1.2 1.2 0 0 1-.21.33q-.147.133-.33.21c-.12.051-.25.078-.38.08M15.69 19.66l1.41 1.16a.52.52 0 0 0 .74-.07.53.53 0 0 0 0-.67l-.24-.29.72-.87L19.64 20a.53.53 0 0 0 .74-.07.53.53 0 0 0 0-.67l-1.17-1.43.94-1.15a.64.64 0 0 0-.08-.9.65.65 0 0 0-.9.09l-1 1.14-1.63-.88a.52.52 0 0 0-.65.12.52.52 0 0 0 .11.75l1.31 1.1-.71.86-.34-.18a.52.52 0 0 0-.756.316.53.53 0 0 0 .186.564M15.75 5 18 3.27 20.25 5v3.33h-1.69V6.64h-1.12v1.69h-1.69z" />
    </g>
    <defs>
      <clipPath id="info-composition_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgInfoComposition;
